import React, { useEffect } from "react";
import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import { useRouteMatch } from "react-router";

import BaseLayout from "../../components/layouts/BaseLayout";
import useSetState from "../../hooks/useSetState";

import BasicTemplates from "./BasicTemplates";
import Transformations from "./Transformations";
import FullTemplates from "./FullTemplates";

const Templates = () => {
  const history = useHistory();
  const match = useRouteMatch({
    path: "/config/templates/:activeTabURL",
    strict: true,
    sensitive: true,
  });
  const { activeTabURL } = match?.params as any;

  const tabs = [
    { label: "Templates", value: "basicTemplates" },
    { label: "Transformations", value: "transformations" },
    { label: "Full Templates", value: "fullTemplates" },
  ];

  const [{ activeTab }, setState] = useSetState({
    activeTab: "basicTemplates",
  });

  useEffect(() => {
    setState({ activeTab: activeTabURL });
  }, [activeTabURL]);

  const handleTabClick = (event, newValue) => {
    history.push(`/config/templates/${newValue}`);
    setState({ activeTab: newValue });
  };
  // @ts-ignore
  return (
    <BaseLayout
      title="Templates"
      tabs={tabs}
      handleTabChange={handleTabClick}
      activeTab={activeTab}
    >
      <Switch>
        <Route path="/config/templates/basicTemplates" exact>
          <BasicTemplates />
        </Route>
        <Route path="/config/templates/transformations" exact>
          <Transformations />
        </Route>
        <Route path="/config/templates/fullTemplates" exact>
          <FullTemplates />
        </Route>
        <Redirect to="/config/templates/basicTemplates" />
      </Switch>
    </BaseLayout>
  );
};

export default Templates;
